import { useEffect, useState } from 'react';
import { api } from './api';
import { BRAND } from './constants';

let _cache = null;
let _pending = null;

const fetchAll = () => {
  if (_cache) return Promise.resolve(_cache);
  if (_pending) return _pending;
  _pending = api.get('/settings')
    .then(r => { _cache = r.data || {}; return _cache; })
    .catch(() => { _cache = {}; return _cache; })
    .finally(() => { _pending = null; });
  return _pending;
};

export const invalidateSettingsCache = () => { _cache = null; };

/**
 * Read site settings. Returns { settings, ready }.
 * settings is always an object — empty until fetch completes (then real values).
 */
export function useSettings() {
  const [state, setState] = useState({ settings: _cache || {}, ready: !!_cache });
  useEffect(() => {
    let alive = true;
    fetchAll().then(s => { if (alive) setState({ settings: s, ready: true }); });
    return () => { alive = false; };
  }, []);
  return state;
}

/** The "Register as MUA" destination link — admin-configurable, falls back to the brand default. */
export function useRegistrationUrl() {
  const { settings } = useSettings();
  return settings.artist_registration_url || BRAND.artistRegistrationUrl;
}
